import { Injectable } from '@angular/core';

import { v4 } from 'uuid';
import { FileElement } from '../file-manager/model/element';
import { BehaviorSubject, Observable } from 'rxjs';
import { RestService } from './rest.service';
import { map } from 'rxjs/operators';
import { StorageService } from "../_services";

export interface IFileService {
  //add(fileElement: FileElement);
  delete(FolderID: string);
  update(FolderID: string, update: Partial<FileElement>);
  queryInFolder(folderId: string): Observable<FileElement[]>;
  get(ParentID: string): FileElement;
}

@Injectable({ providedIn: 'root' })
export class FileService implements IFileService {
  private map = new Map<string, FileElement>();
  private querySubject: BehaviorSubject<FileElement[]> = new BehaviorSubject([]);
  currentUser: any;
  uaInfo: any;

  constructor(private restService: RestService, private storageService: StorageService) {
    this.currentUser = this.storageService.getItem('SignIn');
    this.uaInfo = this.storageService.getItem('uaInfo');
    //this.GetFileList();
  }

  /* add({FolderName, ParentID}: {FolderName: string, ParentID: string | number}) {

    // fileElement.FolderID = v4();
    // this.map.set(fileElement.FolderID, this.clone(fileElement));
    // return fileElement;
  } */

  add(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  delete(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  /* delete(FolderID: string) {
    this.map.delete(FolderID);
  } */
  /* update(reqData:any){
    return this.restService.post(reqData).pipe(map((res:any) => res));
  } */

  update(FolderID: string, update: Partial<FileElement>) {
    let element = this.map.get(FolderID);
    element = Object.assign(element, update);
    this.map.set(element.FolderID, element);
  }

  queryInFolder(folderId: string) {
    const result: FileElement[] = [];
    this.map.forEach(element => {
      if (element.ParentID === folderId) {
        result.push(this.clone(element));
      }
    });
    if (!this.querySubject) {
      this.querySubject = new BehaviorSubject(result);
    } else {
      this.querySubject.next(result);
    }
    return this.querySubject.asObservable();
  }

  get(ParentID: string) {
    return this.map.get(ParentID);
  }

  clone(element: FileElement) {
    return JSON.parse(JSON.stringify(element));
  }
  GetFileList(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  GetFolderList(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  CopyAndMoveData(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  GetFileAndFolderList(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }
  Getzip_link(reqData: any) {
    return this.restService.post(reqData).pipe(map((res: any) => res));
  }

}
